import { render, staticRenderFns } from "./CustomLabel.vue?vue&type=template&id=34e3863b&scoped=true"
import script from "./CustomLabel.vue?vue&type=script&lang=js"
export * from "./CustomLabel.vue?vue&type=script&lang=js"
import style0 from "./CustomLabel.vue?vue&type=style&index=0&id=34e3863b&prod&scoped=true&lang=css"
import style1 from "./CustomLabel.vue?vue&type=style&index=1&id=34e3863b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e3863b",
  null
  
)

export default component.exports